import { render, staticRenderFns } from "./DictionaryData.vue?vue&type=template&id=b4761a6c&scoped=true&"
import script from "./DictionaryData.vue?vue&type=script&lang=js&"
export * from "./DictionaryData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4761a6c",
  null
  
)

export default component.exports